<template>
  <div>
    <div class="intro-y box p-5 mt-5">
      <div class="flex flex-col sm:flex-row sm:items-end xl:items-start justify-end">
        <div class="flex mt-5 sm:mt-0">
          <a
            href="javascript:;"
            data-toggle="modal"
            data-target="#new-company-rate-modal"
            class="btn btn-primary shadow-md mr-2"
            @click="resetID"
          >
            New Company Rate
          </a>

          <div class="dropdown w-1/2 sm:w-auto">
            <button
              class="dropdown-toggle btn btn-outline-secondary w-full sm:w-auto"
              aria-expanded="false"
            >
              <FileTextIcon class="w-4 h-4 mr-2" /> Export
              <ChevronDownIcon class="w-4 h-4 ml-auto sm:ml-2" />
            </button>
            <div class="dropdown-menu w-40">
              <div class="dropdown-menu__content box dark:bg-dark-1 p-2">
                <a
                  id="tabulator-export-csv"
                  href="javascript:;"
                  class="flex items-center block p-2 transition duration-300 ease-in-out bg-white dark:bg-dark-1 hover:bg-gray-200 dark:hover:bg-dark-2 rounded-md"
                  @click="onExportCsv"
                >
                  <FileTextIcon class="w-4 h-4 mr-2" /> Export CSV
                </a>
                <a
                  id="tabulator-export-json"
                  href="javascript:;"
                  class="flex items-center block p-2 transition duration-300 ease-in-out bg-white dark:bg-dark-1 hover:bg-gray-200 dark:hover:bg-dark-2 rounded-md"
                  @click="onExportJson"
                >
                  <FileTextIcon class="w-4 h-4 mr-2" /> Export JSON
                </a>
                <a
                  id="tabulator-export-xlsx"
                  href="javascript:;"
                  class="flex items-center block p-2 transition duration-300 ease-in-out bg-white dark:bg-dark-1 hover:bg-gray-200 dark:hover:bg-dark-2 rounded-md"
                  @click="onExportXlsx"
                >
                  <FileTextIcon class="w-4 h-4 mr-2" /> Export XLSX
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="overflow-x-auto scrollbar-hidden">
        <div
          id="tabulator"
          ref="tableRef"
          class="mt-5 table-report table-report--tabulator"
        ></div>
      </div>
    </div>

    <div id="new-company-rate-modal" class="modal" tabindex="-1" aria-hidden="true">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <h2 class="font-medium text-base mr-auto">Company Rate</h2>
          </div>

          <div class="modal-body grid grid-cols-12 gap-4 gap-y-3">
            <div class="col-span-12">
              <label class="form-label">Carat Range</label>
              <div class="grid grid-cols-12 gap-3">
                <div class="col-span-6">
                  <input
                    v-model="form.weight_from"
                    name="weight_from"
                    type="text"
                    class="form-control"
                    :class="{ 'border-theme-6': v$.weight_from.$error }"
                    placeholder="From Ct"
                    @keypress="$h.preventInvalidInput"
                  />
                  <template v-if="v$.weight_from.$error">
                    <div
                      v-for="(error, index) in v$.weight_from.$errors"
                      :key="index"
                      class="text-theme-6 mt-1"
                    >
                      {{ error.$message }}
                    </div>
                  </template>
                </div>

                <div class="col-span-6">
                  <input
                    v-model="form.weight_to"
                    name="weight_to"
                    type="text"
                    class="form-control"
                    :class="{ 'border-theme-6': v$.weight_to.$error }"
                    placeholder="To Ct"
                    @keypress="$h.preventInvalidInput"
                  />
                  <template v-if="v$.weight_to.$error">
                    <div
                      v-for="(error, index) in v$.weight_to.$errors"
                      :key="index"
                      class="text-theme-6 mt-1"
                    >
                      {{ error.$message }}
                    </div>
                  </template>
                </div>
              </div>
            </div>

            <div class="col-span-12">
              <label class="form-label">Shape</label>
              <TomSelect
                v-model="form.shape"
                :options="{ placeholder: 'Select shape' }"
                class="w-full"
              >
                <option value="round">Round</option>
                <option value="pear">Pear</option>
              </TomSelect>
              <template v-if="v$.shape.$error">
                <div
                  v-for="(error, index) in v$.shape.$errors"
                  :key="index"
                  class="text-theme-6 mt-1"
                >
                  {{ error.$message }}
                </div>
              </template>
            </div>

            <div class="col-span-12">
              <div class="grid grid-cols-12 gap-3">
                <div class="col-span-6">
                  <label class="form-label">Color</label>
                  <TomSelect
                    v-model="form.color"
                    :options="{ placeholder: 'Select color' }"
                    class="w-full"
                  >
                    <option
                      v-for="(item, index) in page_data.color_arr"
                      :key="index"
                      :value="item.color_name"
                    >
                      {{ item.color_name }}
                    </option>
                  </TomSelect>
                  <template v-if="v$.color.$error">
                    <div
                      v-for="(error, index) in v$.color.$errors"
                      :key="index"
                      class="text-theme-6 mt-1"
                    >
                      {{ error.$message }}
                    </div>
                  </template>
                </div>

                <div class="col-span-6">
                  <label class="form-label">Purity</label>
                  <TomSelect
                    v-model="form.purity"
                    :options="{ placeholder: 'Select purity' }"
                    class="w-full"
                  >
                    <option
                      v-for="(item, index) in page_data.clarity_arr"
                      :key="index"
                      :value="item.purity_name"
                    >
                      {{ item.purity_name }}
                    </option>
                  </TomSelect>
                  <template v-if="v$.purity.$error">
                    <div
                      v-for="(error, index) in v$.purity.$errors"
                      :key="index"
                      class="text-theme-6 mt-1"
                    >
                      {{ error.$message }}
                    </div>
                  </template>
                </div>
              </div>
            </div>

            <div class="col-span-12">
              <label class="form-label">Price</label>
              <input
                v-model="form.price"
                name="price"
                type="text"
                class="form-control"
                :class="{ 'border-theme-6': v$.price.$error }"
                placeholder="Enter Price"
                @keypress="$h.preventInvalidInput"
              />
            </div>
          </div>

          <div class="modal-footer text-right">
            <button
              type="button"
              data-dismiss="modal"
              class="btn btn-outline-secondary w-32 mr-1"
            >
              Cancel
            </button>
            <button type="button" class="btn btn-primary w-32" @click="submitForm">
              Save Details
            </button>
          </div>
        </div>
      </div>
    </div>

    <div id="success-notification-content" class="toastify-content hidden flex">
      <CheckCircleIcon class="text-theme-9" />
      <div class="ml-4 mr-4">
        <div class="font-medium">Details saved successfully!</div>
        <div class="text-gray-600 mt-1"></div>
      </div>
    </div>

    <div id="failed-notification-content" class="toastify-content hidden flex">
      <XCircleIcon class="text-theme-6" />
      <div class="ml-4 mr-4">
        <div class="font-medium">Something went wrong!</div>
        <div class="text-gray-600 mt-1">Please check the form fields.</div>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import { defineComponent, ref, reactive, onMounted, inject } from 'vue'
import xlsx from 'xlsx'
import feather from 'feather-icons'
import Tabulator from 'tabulator-tables'
import Toastify from 'toastify-js'
import { useVuelidate } from '@vuelidate/core'
import axios from 'axios'
import { BASE_URL } from '@/constants/config.js'
import { required, numeric, helpers } from '@vuelidate/validators'

export default defineComponent({
  setup() {
    const tableRef = ref()
    const tabulator = ref()
    const swal = inject('$swal')

    const page_data = reactive({
      color_arr: [],
      clarity_arr: []
    })

    const form = reactive({
      weight_from: '',
      weight_to: '',
      color: '',
      shape: 'round',
      purity: '',
      price: '',
      id: ''
    })

    const fromLessThanTo = helpers.withMessage(
      'From Ct must be less than or equal to To Ct',
      (value, vm) => {
        if (!value || !vm.weight_to) return true
        return parseFloat(value) <= parseFloat(vm.weight_to)
      }
    )

    const rules = {
      weight_from: { required, numeric, fromLessThanTo },
      weight_to: { required, numeric },
      color: { required },
      shape: { required },
      purity: { required },
      price: { required, numeric }
    }

    const v$ = useVuelidate(rules, form)

    const oneLine = (cell) =>
      `<div class="truncate">${cell.getValue() ?? ''}</div>`

    const initTabulator = () => {
      tabulator.value = new Tabulator(tableRef.value, {
        ajaxURL: BASE_URL + 'api/master/get_company_rate_details',
        ajaxConfig: {
          method: 'GET',
          headers: {
            'Content-type': 'application/json; charset=utf-8',
            Authorization: 'Bearer ' + localStorage.getItem('token')
          }
        },
        ajaxFiltering: true,
        ajaxSorting: true,
        printAsHtml: true,
        printStyled: true,
        pagination: 'remote',
        paginationSize: 20,
        paginationSizeSelector: [10, 20, 30, 40],
        layout: 'fitColumns',
        headerSort: false,
        responsiveLayout: 'collapse',
        placeholder: 'No matching records found',
        columns: [
          { title: 'From Ct', field: 'weight_from', formatter: oneLine, vertAlign: 'middle', hozAlign: 'center' },
          { title: 'To Ct', field: 'weight_to', formatter: oneLine, vertAlign: 'middle', hozAlign: 'center' },
          { title: 'Color', field: 'color', formatter: oneLine, vertAlign: 'middle', hozAlign: 'center' },
          { title: 'Shape', field: 'shape', formatter: oneLine, vertAlign: 'middle', hozAlign: 'center' },
          { title: 'Purity', field: 'purity', formatter: oneLine, vertAlign: 'middle', hozAlign: 'center' },
          { title: 'Price', field: 'price', formatter: oneLine, vertAlign: 'middle', hozAlign: 'center' },
          {
            title: 'Status',
            field: 'status',
            hozAlign: 'center',
            formatter(cell) {
              const row = cell.getData()
              const a = cash(`<div class="flex items-center justify-center ${row.statusColor}">
                <i data-feather="check-square" class="w-4 h-4 mr-2"></i>
                ${row.status_text}
              </div>`)
              cash(a).on('click', function () {
                toggleStatus(row.id, row.status === 1 ? 0 : 1)
              })
              return a[0]
            }
          },
          {
            title: 'Actions',
            field: 'actions',
            hozAlign: 'center',
            formatter(cell) {
              const row = cell.getData()
              const a = cash(`<div class="flex items-center justify-center">
                <a class="flex items-center mr-3" href="javascript:;">
                  <i data-feather="edit-2" class="w-4 h-4 mr-1"></i> Edit
                </a>
                <a class="flex items-center text-theme-6" href="javascript:;">
                  <i data-feather="trash-2" class="w-4 h-4 mr-1"></i> Delete
                </a>
              </div>`)

              const links = a.find('a')
              cash(links[0]).on('click', () => getDetails(row.id))
              cash(links[1]).on('click', () => deleteItem(row.id))

              return a[0]
            }
          }
        ],
        renderComplete() {
          feather.replace({ 'stroke-width': 1.5 })
        }
      })
    }

    const getDetails = (id) => {
      axios({
        url: 'api/master/get_company_rate_details_by_id',
        method: 'POST',
        data: { id },
        baseURL: BASE_URL,
        headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
      }).then((res) => {
        const item = res.data.data
        form.weight_from = item.weight_from
        form.weight_to = item.weight_to
        form.color = item.color
        form.shape = item.shape
        form.purity = item.purity
        form.price = item.price
        form.id = item.id

        get_color_details('update')
        get_purity_details('update')
        cash('#new-company-rate-modal').modal('show')
      })
    }

    const submitForm = () => {
      v$.value.$touch()
      if (v$.value.$invalid) {
        Toastify({
          node: cash('#failed-notification-content').clone().removeClass('hidden')[0],
          duration: 3000,
          gravity: 'top',
          position: 'right'
        }).showToast()
        return
      }

      const params = { ...form }
      const promiseUrl =
        form.id !== '' && form.id != null
          ? 'api/master/update_company_rate_details'
          : 'api/master/add_company_rate_details'

      axios({
        url: promiseUrl,
        method: 'POST',
        data: params,
        baseURL: BASE_URL,
        headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
      }).then(() => {
        Toastify({
          node: cash('#success-notification-content').clone().removeClass('hidden')[0],
          duration: 3000,
          gravity: 'top',
          position: 'right'
        }).showToast()

        cash('#new-company-rate-modal').modal('hide')
        resetForm()
        v$.value.$reset()
        tabulator.value.setData()
      })
    }

    const toggleStatus = (id, status) => {
      swal
        .fire({
          title: 'Are you sure?',
          text: "You won't be able to change status!",
          icon: 'warning',
          showCancelButton: true,
          confirmButtonText: 'Yes, do it!',
          customClass: {
            confirmButton: 'btn btn-primary',
            cancelButton: 'btn btn-outline-danger ml-2'
          },
          buttonsStyling: false
        })
        .then((result) => {
          if (result.value) {
            axios({
              url: 'api/master/delete_company_rate_details',
              method: 'POST',
              data: { id, action: 'toggle', status },
              baseURL: BASE_URL,
              headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
            }).then(() => {
              tabulator.value.setData()
            })
          }
        })
    }

    const deleteItem = (id) => {
      swal
        .fire({
          title: 'Are you sure?',
          text: "You won't be able to revert this!",
          icon: 'warning',
          showCancelButton: true,
          confirmButtonText: 'Yes, delete it!',
          customClass: {
            confirmButton: 'btn btn-primary',
            cancelButton: 'btn btn-outline-danger ml-2'
          },
          buttonsStyling: false
        })
        .then((result) => {
          if (result.value) {
            axios({
              url: 'api/master/delete_company_rate_details',
              method: 'POST',
              data: { id, action: 'delete' },
              baseURL: BASE_URL,
              headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
            }).then(() => {
              tabulator.value.setData()
            })
          }
        })
    }

    const resetForm = () => {
      form.weight_from = ''
      form.weight_to = ''
      form.color = ''
      form.shape = 'round'
      form.purity = ''
      form.price = ''
      form.id = ''
      get_color_details('create')
      get_purity_details('create')
    }

    const resetID = () => resetForm()

    const onExportCsv = () => tabulator.value.download('csv', 'data.csv')
    const onExportJson = () => tabulator.value.download('json', 'data.json')
    const onExportXlsx = () => {
      const win = window
      win.XLSX = xlsx
      tabulator.value.download('xlsx', 'data.xlsx', { sheetName: 'CompanyRate' })
    }

    const get_color_details = (type) => {
      axios({
        url: 'api/master/dp_color',
        method: 'post',
        baseURL: BASE_URL,
        headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
      })
        .then((res) => {
          page_data.color_arr = res.data.items || []

          if(type == 'create') {
            form.color = page_data.color_arr[0].color_name
          }
        })
        .catch(() => {
          page_data.color_arr = []
        })
    }

    const get_purity_details = (type) => {
      axios({
        url: 'api/master/dp_purity',
        method: 'post',
        baseURL: BASE_URL,
        headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
      })
        .then((res) => {
          page_data.clarity_arr = res.data.items || []

          if(type == 'create') {
            form.purity = page_data.clarity_arr[0].purity_name
          }
        })
        .catch(() => {
          page_data.clarity_arr = []
        })
    }

    onMounted(() => {
      get_color_details()
      get_purity_details()
      initTabulator()
    })

    return {
      page_data,
      tableRef,
      form,
      v$,
      submitForm,
      resetForm,
      resetID,
      onExportCsv,
      onExportJson,
      onExportXlsx
    }
  }
})
</script>
